var KnowAboutData = [
  {
    id: 1,
    process: "Register Yourself",
    imgUrl: "user.png",
  },
  {
    id: 2,
    process: "View Candidates",
    imgUrl: "view.png",
  },
  {
    id: 3,
    process: "Post Openings",
    imgUrl: "job.png",
  },
  {
    id: 4,
    process: "Get Applicants",
    imgUrl: "check.png",
  },
  {
    id: 5,
    process: "Shortlist & Hire",
    imgUrl: "thumb.png",
  },
];

export default KnowAboutData;
